<div class="flex flex-col gap-6">
    <app-overridable-section
        title="KYC Requirements"
        [overridden]="overridden()"
        (overriddenChange)="onToggle($event)"
        [dirty]="dirty()"
        [importable]="false"
    >
        <app-category-kyc-form [(value)]="draft" [disabled]="!overridden()" />
    </app-overridable-section>

    <div class="card flex flex-col gap-3 max-w-xl">
        <div class="flex items-center justify-between gap-2">
            <div class="font-semibold text-xl">Sumsub</div>
            <p-tag severity="info" [value]="'Inherited from ' + sumsubSourceLabel()" />
        </div>
        <div>
            <label class="block font-medium mb-1">Sumsub Level Name</label>
            <div class="text-muted-color">{{ sumsub().Value.LevelName || '—' }}</div>
            <small class="text-muted-color">Configured at the category level; cannot be overridden per realm.</small>
        </div>
    </div>
</div>
